<template>
  <a-row class="head">
    <a-col :span="20" class="logo">
      <img src="../assets/images/gameone_com_hk_logo_709x108.jpg" style="height: 80px;" />
    </a-col>
    <a-col :span="4" class="language">
      <a-button type="link" @click="languageClick">{{ language_label }}</a-button>
    </a-col>
  </a-row>
  <ul class="main-menu">
    <li v-for="item in menu" :key="item.id">
      <a @click="menuClick(item.id)">{{item.name}}</a>
      <CaretDownOutlined class="icon" v-show="item.children.length > 1" />
      <ul class="sub-menu" v-if="item.children.length > 1">
        <li v-for="sub_item in item.children" :key="sub_item.id"><a @click="menuClick(sub_item.id)">{{sub_item.name}}</a></li>
      </ul>
    </li>
  </ul>

  <div class="banner">
    <img src="../assets/images/gameone_com_hk_banner_1920X280_27jan2021.jpg" style="width: 100%" />
  </div>
  <a-row class="content-box" :gutter="24">
    <a-col :span="6" class="left-menu">
      <ul class="left-menu-ul">
        <li v-for="item in left_menu" :key="item.id">
          <a @click="menuClick(item.id)">{{ item.name }}</a>
        </li>
      </ul>
    </a-col>
    <a-col :span="18" class="content">
      <div class="title">{{ title }}</div>      
      <div class="content-page" v-if="type == 'about'" v-html="content"></div>

      <div class="content-page" v-if="type == 'time_line'">       
        <div class="content-list" v-for="(item, item_index) in items" :key="item_index">
          <a-tag color="#ff7a45">{{ item.show_date }}</a-tag> {{ item.title }}
        </div>
      </div>

      <div class="content-page image_list_box" v-if="type == 'image_list'">       
        <template v-for="(item, item_index) in items" :key="item_index">
          <a :href="item.href" target="_blank" class="image_list">
            <img :src="item.src" />
            <div class="image_list_text">{{ item.title }}</div>
          </a>
        </template>
      </div>

      <div class="down_list_box" v-if="type == 'down_list'">
        <a-row class="down_list" :gutter="10" v-for="(item, item_index) in items" :key="item_index">
          <a-col :span="20" class="col-1">
            <a :href="item.href" target="_blank" class="link">{{ item.title }}</a>
          </a-col>
          <a-col class="col-2" :span="4">{{ item.show_date }}</a-col>
        </a-row>
        <div style="margin-top: 20px;">
          <a-pagination v-model:current="page.current" :total="page.total" :show-size-changer="false" @change="pageClick" />
        </div>
      </div>

      <div class="image_list_box year_images_box" v-if="type == 'group_image_list'">
        <template v-for="(item, item_index) in items" :key="item_index">
          <h3 class="group_title">{{ item.group }}</h3>
          <div style="vertical-align: top;">
            <template v-for="(img, item_item_index) in item.items" :key="item_item_index">
              <a :href="img.href" target="_blank" class="image_list">
                <img :src="img.src" />
                <div class="image_list_text">{{ img.title }}</div>
              </a>
            </template>
          </div>
        </template>
      </div>
    </a-col>
  </a-row>

  <div class="footer" v-html="footer"></div>
</template>

<script>
import {
  Tag,
  Button, 
  Row, 
  Col,  
  message,
  Pagination,
} from 'ant-design-vue'

import {
  CaretDownOutlined
} from '@ant-design/icons-vue';

import axios from 'axios'

export default {
  name: 'IndexHome',
  components: {
    aRow: Row,
    aCol: Col,
    aTag: Tag,
    aButton: Button,
    aPagination: Pagination,
    CaretDownOutlined: CaretDownOutlined,    
  },

  data() {
    return {
      current: ['mail'],
      language_label: "English",
      language: "cn",
      left_menu: [],
      page_id: 1,
      content_id: 1,
      menu: {},  
      page: {
        current: 1,
        total: 1
      },
      title: '',
      type: '',
      content: '',
      items: [],  
      footer: 'Copyright © 2025 Gameone Group Limited All Rights Reserved.'
    }
  },
  methods: {    
    languageClick: function () {
      this.language = this.language == 'cn' ? 'en' : 'cn'
      this.language_label = this.language == 'cn' ? 'English' : '中文'
      this.menuData()
      this.contentData()
    },
    menuData: function() {
      axios.get('/api/index?language=' + this.language)
        .then((response) => {
          let res = response.data
          if (res.status == 1) {
            this.menu = res.data
            if (this.menu[this.page_id] && this.menu[this.page_id].children && this.menu[this.page_id].children.length > 1) {
              this.left_menu = this.menu[this.page_id].children
            }
          } else {
            console.log(response)
            message.error('Service Error')
          }
        })
        .catch((err) => {
          console.log(err)
          message.error(err?.message || 'Service Error')
        })
      axios.get('/api/footer?language=' + this.language)
        .then((response) => {
          let res = response.data
          if (res.status == 1) {
            if (res.data.footer != undefined) {
              console.log(res.data.footer)
              this.footer = res.data.footer
            }
            
          } else {
            console.log(response)
            message.error('Service Error')
          }
        })
        .catch((err) => {
          console.log(err)
          message.error(err?.message || 'Service Error')
        })
    },
    contentData: async function() {
      await axios.get('/api/content?language=' + this.language + '&id='+ this.content_id + '&page=' + this.page.current)
      .then((res) => {
        res = res.data
        console.log(res)
        if (res.status == 1) {          
          if (res.data.type == 'about') {
            this.content = res.data.content
          } else if (res.data.type == 'down_list') {
            this.items = res.data.items
            this.page.total = res.data.total
          } else {
            this.items = res.data.items
          }
          this.title = res.data.title
          this.type = res.data.type
          if (this.menu[res.data.parent_id] && this.menu[res.data.parent_id].children && this.menu[res.data.parent_id].children.length > 1) {
            this.left_menu = this.menu[res.data.parent_id].children
          }
        } else {
          message.error('Service Error')
        }
      })
      .catch((err) => {
        console.log(err)
        message.error(err?.message || 'Service Error')
      })
    },
    menuClick: function (id) {
      console.log(id)
      this.content_id = id
      this.contentData()
    },
    pageClick: function (page) {
      this.page.current = page
      this.contentData()
    }
  },
  created: async function() {
    this.menuData();
    await this.contentData();    
  }   
}
</script>

<style src="../assets/style/index.css" />
